import React from 'react'
import './productSearch.css'
import { getProductImageUrl } from 'Utils/getProductImageUrl'
import { Formatter } from 'Utils/Formatter'
import Loading from 'Components/Loading'
import { t } from 'i18next'
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined'
import { useCustomerDisplay } from 'Views/CustomerDisplay/context/CustomerDisplayContext'
import { createCustomerDisplayId } from 'Views/CustomerDisplay/utils/customerDisplayId'

const getCustomerDisplayAddRequestId = product => {
  const productKey = product?.ProductId || product?.Sku || 'product'
  const requestKey = createCustomerDisplayId()

  return `${productKey}-${requestKey}`
}

const ProductSearch = ({ listProducts, isLoading }) => {
  const { postToMainApp } = useCustomerDisplay()
  const hasProducts = listProducts?.length > 0

  return (
    <div
      className="container-product-search"
      id="container-product-search"
      data-testid="container-product-search">
      {hasProducts && (
        <h1 className="title-product-search" data-testid="title-product-search">
          {t('CUSTOMER_DISPLAY.TITLE_PRODUCT_SEARCH', {
            quantity: listProducts?.length,
          })}
        </h1>
      )}

      <div
        className="continer-product-card-product-search"
        data-testid="container-product-cards">
        {isLoading && (
          <div className="loading-overlay">
            <Loading full />
          </div>
        )}
        {!isLoading && !hasProducts && (
          <div
            className="empty-product-search"
            data-testid="empty-product-search"
            role="status">
            <SearchOffOutlinedIcon className="empty-product-search-icon" />
            <h2>{t('CUSTOMER_DISPLAY.NO_RESULTS_AVAILABLE')}</h2>
          </div>
        )}
        {hasProducts &&
          listProducts.map((product, index) => (
            <React.Fragment key={product?.ProductId || product?.Sku || index}>
              <div
                className="product-card-wrapper-product-search"
                data-testid="card__product-search">
                <div className="product-card-search">
                  <div>
                    <div className="product-card-image-product-search">
                      <img
                        data-testid="btn-view-product-detail"
                        src={getProductImageUrl(product)}
                        onClick={() => {
                          postToMainApp({
                            isProductDetail: true,
                            isSearchProducts: false,
                            productDetail: product,
                          })
                        }}
                        alt={product.ProductName}
                        className="img-fluid"
                      />
                    </div>
                    <div className="product-card-generals-product-search">
                      <h2
                        className="product-card-generals-title-product-search"
                        data-testid="text-product-name">
                        {product.ProductName}
                      </h2>
                      <p
                        className="product-card-brand-product-search"
                        data-testid="text-product-brand">
                        {product.Brand}
                      </p>
                      <p
                        className="product-card-sku-product-search"
                        data-testid="text-product-sku">
                        {product.Sku}
                      </p>
                      <div
                        className="product-card-price-product-search"
                        data-testid="container-product-price">
                        <p data-testid="text-product-final-price">
                          {product.FinalPrice === undefined
                            ? 'Sin precio'
                            : '$' + Formatter.Money(product.FinalPrice)}
                        </p>
                        <div
                          className="product-promo"
                          data-testid="tag-product-promo"
                          style={{
                            display: product.Promo ? 'block' : 'none',
                          }}>
                          <p>{product.Promo || 'No Promo'}</p>
                        </div>
                        {product.BasePrice - product.FinalPrice > 0 && (
                          <div
                            className="product-promo"
                            data-testid="tag-product-offer">
                            Oferta
                          </div>
                        )}
                        {product.FinalPrice < product.BasePrice && (
                          <p
                            data-testid="text-product-base-price"
                            style={{
                              textDecoration: 'line-through',
                              color: 'gray',
                            }}>
                            {`$${Formatter.Money(product.BasePrice)}`}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="product-card-buttons-product-search">
                    <button
                      type="button"
                      data-testid="btn-add-product-cart"
                      onClick={() => {
                        postToMainApp({
                          isAddedProduct: true,
                          customerDisplayAddRequestId:
                            getCustomerDisplayAddRequestId(product),
                          productCart: product,
                        })
                      }}>
                      Agregar
                    </button>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
      </div>
    </div>
  )
}

export default ProductSearch
